import { useCallback } from 'react';

import { usePostApiUserSettingsMutation } from 'applications/GSP/shared/api/gsp';
import { MutationCacheKey } from 'applications/GSP/shared/constants/mutation';

import type { InspiredGlobalStudyPlatformApiModelsSchoolSettingsSupportedLocale as LocaleType } from 'applications/GSP/shared/api/gsp';

export const useSelectLocale = () => {
  const [postApiUserSettings] = usePostApiUserSettingsMutation({
    fixedCacheKey: MutationCacheKey.UserSettingsMutation,
  });

  return useCallback(
    (locale: LocaleType['id']) => {
      postApiUserSettings({
        inspiredGlobalStudyPlatformApiModelsUserSettingsUpdateUserSettingsRequest:
          { locale },
      });
    },
    [postApiUserSettings],
  );
};
